import { RATING_SENTIMENT_DISSATISFIED, RATING_SENTIMENT_HIGHLY_SATISFIED, RATING_SENTIMENT_SATISFIED, RATING_SENTIMENT_VERY_DISSATISFIED, RATING_SENTIMENT_VERY_SATISFIED, REVIEW_SCORE_THRESHOLD_EXCELLENT, REVIEW_SCORE_THRESHOLD_FAIR, REVIEW_SCORE_THRESHOLD_GOOD, REVIEW_SCORE_THRESHOLD_VERY_GOOD } from '../../primitives/Rating/models.js';
const colorTokensBySentiment = {
  [RATING_SENTIMENT_VERY_DISSATISFIED]: 'contentAdditionalB',
  [RATING_SENTIMENT_DISSATISFIED]: 'contentAdditionalC',
  [RATING_SENTIMENT_SATISFIED]: 'contentAdditionalE',
  [RATING_SENTIMENT_VERY_SATISFIED]: 'contentAdditionalD',
  [RATING_SENTIMENT_HIGHLY_SATISFIED]: 'systemPositive'
};
export const getColorTokenBySentiment = sentiment => {
  return colorTokensBySentiment[sentiment] || '';
};
export const mapScoreToSentiment = score => {
  if (score >= REVIEW_SCORE_THRESHOLD_EXCELLENT) {
    return RATING_SENTIMENT_HIGHLY_SATISFIED;
  }
  if (score >= REVIEW_SCORE_THRESHOLD_VERY_GOOD) {
    return RATING_SENTIMENT_VERY_SATISFIED;
  }
  if (score >= REVIEW_SCORE_THRESHOLD_GOOD) {
    return RATING_SENTIMENT_SATISFIED;
  }
  if (score >= REVIEW_SCORE_THRESHOLD_FAIR) {
    return RATING_SENTIMENT_DISSATISFIED;
  }
  return RATING_SENTIMENT_VERY_DISSATISFIED;
};